/**
 * Represents the zeus.apollon_fk_conf.conf.objekte[...].rahmen value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, Model, type MutationsObject } from '@kp/js-model';
import { ProjektFeld } from '@/models/apollon_conf_fk/ProjektFeld';

export class ObjektRahmen extends Model {
    public rahmen_ident: string | null = null;
    public label: string | null = null;
    public zeus_label: string | null = null;
    public einreichung: string | null = null;
    public einreichung_from: string | null = null;
    public einreichung_to: string | null = null;
    public abschluss: string | null = null;
    public abschluss_from: string | null = null;
    public abschluss_to: string | null = null;
    public hilfetext: string | null = null;
    public felder: { [key: string]: ProjektFeld } = {};

    public mutations(): MutationsObject {
        return {
            felder: (val: { [key: string]: ProjektFeld }) => {
                if (val) {
                    for (const key in val) {
                        val[key] = createModel(ProjektFeld, val[key]);
                    }
                }
                return val;
            }
        };
    }
}
